import { WaitingContractRequestSortKey } from "graphql/type";

import { applicationStatusNumber } from "./status";

export enum ENUM_CUSTOMER_TABS {
  APPLICATION_CONTRACT = "application-contract",
  UNDER_CONTRACT = "under-contract",
  CONTRACT_CANCELLED = "contract-cancelled",
  WAITING_CONTRACT = "waiting-contract",
}

export enum ENUM_APPLICATION_STATUS {
  TEMPORARY_STORAGE = "TEMPORARY_STORAGE",
  APPLICATION_ACCEPTANCE = "APPLICATION_ACCEPTANCE",
  SCREENING = "SCREENING",
  CONTRACT = "CONTRACT",
  APPLICATION_NG = "APPLICATION_NG",
  APPRAISAL_NG = "APPRAISAL_NG",
  CONTRACT_NG = "CONTRACT_NG",
  CONTRACT_COMPLETED = "CONTRACT_COMPLETED",
  CANCELLATION_ACCEPTANCE = "CANCELLATION_ACCEPTANCE",
  CANCELLATION_SCHEDULED = "CANCELLATION_SCHEDULED",
  CONTRACT_FORCE_CANCELED = "CONTRACT_FORCE_CANCELED",
  CONTRACT_NORMAL_CANCELED = "CONTRACT_NORMAL_CANCELED",
}

export enum ENUM_WAITING_CONTRACT_STATUS {
  WAITING = "WAITING",
  DONE = "DONE",
}

export const CUSTOMER_TABS = [
  {
    id: ENUM_CUSTOMER_TABS.APPLICATION_CONTRACT,
    label: "申込〜契約",
  },
  {
    id: ENUM_CUSTOMER_TABS.UNDER_CONTRACT,
    label: "契約中",
  },
  {
    id: ENUM_CUSTOMER_TABS.CONTRACT_CANCELLED,
    label: "解約済み",
  },
  // {
  //   id: ENUM_CUSTOMER_TABS.WAITING_CONTRACT,
  //   label: "空き待ち",
  // },
];

export const DASHBOARD_STATUS_FILTER: Record<number, string> = {
  [applicationStatusNumber.APPLICATION_ACCEPTANCE]: "申込受付",
  [applicationStatusNumber.SCREENING]: "審査",
  [applicationStatusNumber.CONTRACT]: "契約",
  [applicationStatusNumber.CONTRACT_COMPLETED]: "契約中",
};

export const APPLICATION_STATUS = {
  [ENUM_CUSTOMER_TABS.APPLICATION_CONTRACT]: [
    {
      id: undefined,
      label: "すべて",
      isShow: true,
    },
    {
      id: ENUM_APPLICATION_STATUS.APPLICATION_ACCEPTANCE,
      label: "申込受付",
      isShow: true,
    },
    {
      id: ENUM_APPLICATION_STATUS.SCREENING,
      label: "審査",
      isShow: true,
    },
    {
      id: ENUM_APPLICATION_STATUS.CONTRACT,
      label: "契約",
      isShow: true,
    },
    {
      id: ENUM_APPLICATION_STATUS.APPLICATION_NG,
      label: "",
      isShow: false,
    },
    {
      id: ENUM_APPLICATION_STATUS.APPRAISAL_NG,
      label: "",
      isShow: false,
    },
    {
      id: ENUM_APPLICATION_STATUS.CONTRACT_NG,
      label: "",
      isShow: false,
    },
  ],
  [ENUM_CUSTOMER_TABS.UNDER_CONTRACT]: [
    {
      id: undefined,
      label: "すべて",
      isShow: true,
    },
    {
      id: ENUM_APPLICATION_STATUS.CONTRACT_COMPLETED,
      label: "契約中",
      isShow: true,
    },
    {
      id: ENUM_APPLICATION_STATUS.CANCELLATION_ACCEPTANCE,
      label: "解約受付",
      isShow: true,
    },
    {
      id: ENUM_APPLICATION_STATUS.CANCELLATION_SCHEDULED,
      label: "解約予定",
      isShow: true,
    },
  ],
  [ENUM_CUSTOMER_TABS.CONTRACT_CANCELLED]: [
    {
      id: undefined,
      label: "すべて",
      isShow: true,
    },
    {
      id: ENUM_APPLICATION_STATUS.CONTRACT_NORMAL_CANCELED,
      label: "通常解約",
      isShow: true,
    },
    {
      id: ENUM_APPLICATION_STATUS.CONTRACT_FORCE_CANCELED,
      label: "強制解約",
      isShow: true,
    },
  ],
  [ENUM_CUSTOMER_TABS.WAITING_CONTRACT]: [
    {
      id: undefined,
      label: "すべて",
      isShow: true,
    },
    {
      id: ENUM_WAITING_CONTRACT_STATUS.WAITING,
      label: "空き待ち中",
      isShow: true,
    },
    {
      id: ENUM_WAITING_CONTRACT_STATUS.DONE,
      label: "空き待ち終了",
      isShow: true,
    },
  ],
};

export const WAITING_CONTRACT_STATUS_CODE = {
  WAITING: 0,
  DONE: 1,
};

export const WAITING_CONTRACT_STATUS = {
  [WAITING_CONTRACT_STATUS_CODE.WAITING]: {
    label: "空き待ち中",
    id: ENUM_WAITING_CONTRACT_STATUS.WAITING,
  },
  [WAITING_CONTRACT_STATUS_CODE.DONE]: {
    label: "空き待ち終了",
    id: ENUM_WAITING_CONTRACT_STATUS.DONE,
  },
};

export const WAITING_CONTRACT_HEADERS: { name: string; field?: keyof WaitingContractRequestSortKey }[] = [
  { name: "ステータス", field: "status" },
  { name: "契約者", field: "companyName" },
  { name: "駐車場", field: "waitingContractProperty.propertyName" as keyof WaitingContractRequestSortKey },
  { name: "車種", field: "carModel" },
  { name: "空き待ち予約日", field: "createdAt" },
  { name: "空き待ち期間", field: "availableSlotsTime" as keyof WaitingContractRequestSortKey },
];

export const CUSTOMER_PATHNAME = {
  CHAT: "chat",
  CONFIRM: "confirm",
  REVIEW: "review",
  CONTRACT: "contract",
  UNDER_CONTRACT: "under-contract",
  CANCELLED_CONTRACT: "cancelled-contract",
  DOCUMENT_ISSUANCE: "document-issuance",
  RENTAL_INFORMATION: "rental-information",
};

export const CONTRACT_PATHNAME = {
  SEND_CONTRACT: "send-contract",
};

export const PAYMENT_METHODS = {
  CREDIT_CARD: {
    type: 0,
    label: "クレジットカード",
  },
  BANK_TRANSFER: {
    type: 1,
    label: "その他の支払い方法（銀行引落）",
  },
} as const;

export const REGISTER_CUSTOMER_STEP = {
  CONTRACT_INFO: 1,
  CONTRACT_DETAIL_USER_INFO: 2,
  EMERGENCY_CONTACT: 3,
  CONTRACT_METHOD: 4,
};

export enum ENUM_PREFERRED_CONTRACT {
  PERSON = "0",
  CORPORATE = "1",
}

export enum ENUM_APPLICATION_TYPE {
  PARKSTOCK = "PARKSTOCK",
  MANUAL_REGISTRATION = "MANUAL_REGISTRATION",
}

export enum ENUM_APPLICATION_CONTRACT_TYPE {
  DOCUMENT_CONTRACT = "DOCUMENT_CONTRACT",
  ONLINE_CONTRACT = "ONLINE_CONTRACT",
}
